import { render, staticRenderFns } from "./GenericSettings.vue?vue&type=template&id=56fc5ce6&scoped=true&"
import script from "./GenericSettings.vue?vue&type=script&lang=ts&"
export * from "./GenericSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GenericSettings.vue?vue&type=style&index=0&id=56fc5ce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc5ce6",
  null
  
)

export default component.exports